import { Factory } from 'rosie';

const userId = 'example-user-id';

Factory.define('UserEditor').attr('name', 'USER_EDITOR');

Factory.define('UserEditorWithDefaults').extend('UserEditor').attr('userId', userId);
